import React, { Component, StrictMode } from 'react';

import MomentUtils from '@date-io/moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';

import { IActionGroup, IStore, Provider, store, IStoreActions } from './store';

import { bindActions } from './contrib/store';
import { PX } from './contrib/ui';
import theme from './styles/theme';
import { RouteInfoProvider } from './components/RouteInfo/Context/RouteInfo.context';
import RouteInfo from './components/RouteInfo/RouteInfo';
import { ContentRouter, FooterRouter, HeaderRouter } from './routes/routes';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

class App extends Component<{}, IStore> {
  constructor(props: any) {
    super(props);
    const actions = bindActions(this) as IStoreActions;
    this.state = { ...store, actions };
    if (this.state.auth.isAuthenticated) {
      actions.auth.refreshToken();
    }
  }

  public actionSelector(...actions: string[]): IActionGroup {
    const out: IActionGroup = {};
    const allActions = ['auth', 'errors', 'notifications', 'pages', ...actions];
    allActions.forEach((action: string) => {
      out[action] = this.state.actions[action];
    });
    return out;
  }

  public render(): React.ReactNode {
    // setting global variable PX because some devices fail to calculate it from
    // CSS when is expressed in vh units
    document.documentElement.style.setProperty('--px', `${PX}px`);
    const selector = this.actionSelector.bind(this);

    return (
      <ErrorBoundary>
        <StrictMode>
          <Provider value={this.state}>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <RouteInfoProvider>
                  <RouteInfo />

                  <HeaderRouter actionSelector={selector} />

                  <ContentRouter actionSelector={selector} />

                  <FooterRouter />
                </RouteInfoProvider>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </Provider>
        </StrictMode>
      </ErrorBoundary>
    );
  }
}

export default App;
